class WohlFuhlHeaderLayout extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
    } else {
      this.initialize();
    }
  }

  initialize() {
    const section = this.closest('.shopify-section--header');
    this.header = section?.querySelector('.header');
    this.announcement = section?.querySelector('.promo-banner');
    if (!this.header) return;
    const { signal } = this.controller;
    const refresh = () => this.schedule();
    this.resizeObserver = new ResizeObserver(refresh);
    this.resizeObserver.observe(this.header);
    if (this.announcement) this.resizeObserver.observe(this.announcement);
    this.mutationObserver = new MutationObserver(refresh);
    this.mutationObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    this.mutationObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', refresh, { signal });
    window.addEventListener('load', () => this.schedule(true), { once: true, signal });
    for (const type of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
      document.addEventListener(type, () => this.schedule(true), { signal });
    }
    document.fonts.ready.then(() => {
      if (!signal.aborted) this.schedule(true);
    });
    this.schedule(true);
  }

  schedule(force = false) {
    this.forceRefresh ||= force;
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.synchronize();
    });
  }

  synchronize() {
    const firstSection = document.querySelector('.global-wrapper .shopify-section');
    const hero = firstSection?.classList.contains('parallax-banner') ? firstSection : null;
    if (this.hero !== hero) {
      this.hero?.removeAttribute('data-wm-header-spacing');
      this.hero?.removeAttribute('data-wm-home-hero');
    }
    this.hero = hero;
    hero?.toggleAttribute('data-wm-home-hero', document.body.classList.contains('index'));
    const active = Boolean(hero && matchMedia('(min-width: 799px)').matches && this.header.matches('.header-background--true.header-transparency--false.sticky-header--false'));
    this.header.toggleAttribute('data-wm-announcement-layout', active);
    hero?.toggleAttribute('data-wm-header-spacing', active);
    const headerHeight = active ? this.header.getBoundingClientRect().height : 0;
    const announcementHeight = active && document.body.classList.contains('promo-banner--true') ? this.announcement?.getBoundingClientRect().height || 0 : 0;
    if (active) {
      document.documentElement.style.setProperty('--wm-header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--wm-announcement-height', `${announcementHeight}px`);
    } else if (this.active) {
      this.clearProperties();
    }
    this.active = active;
    const signature = `${active}|${headerHeight}|${announcementHeight}|${innerWidth}|${innerHeight}|${hero?.id}`;
    if (this.forceRefresh || signature !== this.signature) {
      this.signature = signature;
      if (hero) window.dispatchEvent(new Event('scroll'));
    }
    this.forceRefresh = false;
  }

  clearProperties() {
    document.documentElement.style.removeProperty('--wm-header-height');
    document.documentElement.style.removeProperty('--wm-announcement-height');
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    cancelAnimationFrame(this.frame);
    this.header?.removeAttribute('data-wm-announcement-layout');
    this.hero?.removeAttribute('data-wm-header-spacing');
    this.hero?.removeAttribute('data-wm-home-hero');
    if (this.active) this.clearProperties();
    this.controller = null;
    this.frame = null;
    this.active = false;
  }
}

if (!customElements.get('wm-header-layout')) customElements.define('wm-header-layout', WohlFuhlHeaderLayout);
